import { Button, Grid, TextField } from '@mui/material'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { authContext } from '../../context/AuthContext'
import { GridAutoTextField } from '../helper/GridComponents'
import Loading from '../helper/Loading'
import PageHeader from '../helper/PageHeader'
import { SearchBarCourseTitle } from '../helper/SearchBars'
import SimpleTable from '../helper/SimpleTable'
import DeleteDialog from '../helper/Dialogs'

const tableCells = [
    { id: 'label', label: 'Module Title', centered: false },
];

const AdminManageCourses = props => {
    const [courseOptions, setCourseOptions] = useState(null) // the options for selecting which course (autocomplete)
    const [course, setCourse] = useState(null) // the selected course (autocomplete) // tried this JSON.parse(sessionStorage.getItem('courseSearch')) || null, didn't work because of autocomplete options not loaded (would work if stored autocomp options in storage)
    const [subModules, setSubModules] = useState(null) // the sub modules found for the course (the upper table)
    const [changesMade, setChangesMade] = useState(false) // if any changes were made to the course relations
    const [searchModules, setSearchModules] = useState({ modules: null, loading: false }) // the results of the search (the lower table)
    const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null }) // the delete dialog

    const [selectedCourseFromSearch, setSelectedCourseFromSearch] = useState(null)

    const mounted = useRef(true)

    const history = useHistory()
    const user = useContext(authContext)

    // console.log("render", mounted, subModules)

    // grab drop down options
    useEffect(() => {
        async function fetchOptions() {
            const res = await axios.get('/api/course')
            const data = res.data.courses.map((course) => ({ label: course.label, value: course.id }))
            if (mounted.current) {
                setCourseOptions(data)
                const memory = JSON.parse(sessionStorage.getItem('courseSearch'));
                if (memory) setCourse(memory)
            }


        }

        fetchOptions()

        return () => mounted.current = false

    }, [])

    // called when the course or the course from search is changed
    // perform search/update table when course option selected
    useEffect(() => {
        async function fetchSubOptions() {
            setSubModules(null) // clear the existing modules so the loading component shows up
            setChangesMade(false) //clear changes made state so the save changes button is disabled again if changes made but not saved and then switched to different course

            // if not course is selected, set as null (which displays no course selected)
            if (course === null && selectedCourseFromSearch === null) {
                setSubModules(null)
                return
            }

            // if the course is selected from the search bar, then use that one. Otherwise use the course from the autocomplete
            let id
            if (selectedCourseFromSearch !== null) id = selectedCourseFromSearch.value
            else id = course.value

            // grab the submodules if any
            const res = await axios.get('/api/course/' + id)
            console.log("RES", res.data.modules)

            // disable the action buttons on the top and bottom submodules and then set
            const modules = disableActions(res.data.modules)
            if (mounted.current) {
                setSubModules(modules)
            }

        }

        fetchSubOptions()
    }, [course, selectedCourseFromSearch])

    const disableActions = array => {
        const length = array.length
        return array.map((e, index) => {
            e.actionsDisabled = {
                up: index === 0, //disable if the first index
                down: index === length - 1 //disable if the last index
            }
            return e
        })
    }

    const handleCourse = (event, value) => {
        if (value !== null) sessionStorage.setItem('courseSearch', JSON.stringify(value)) // set session storage if not null
        setCourse(value)
    }

    const handleCourseSearch = async (search) => {
        setSearchModules({ modules: null, loading: true })
        const res = await axios.get('/api/course/search/', {
            params: {
                title: search.title
            }
        })
        console.log("In search", res)
        setSearchModules({ modules: res.data.courses, loading: false })

    }


    const onCreateCourse = () => {
        history.push('/administration/manageCourses/create')
    }

    // move up down grabs the id fields, then swaps if able, then joins array with comma
    const onMoveUp = option => {
        const newArray = [...subModules]
        const index = newArray.findIndex(e => e.id === option)
        // swap only if not the first element
        if (index !== -1 && index > 0) {
            let el = newArray[index];
            newArray[index] = newArray[index - 1];
            newArray[index - 1] = el;

            const arrayAsString = newArray.map(e => e.id).join(",") // pull out the id's, then converts to string
            console.log("Swapping: Original", subModules, "New", newArray, "as string", arrayAsString)
            updateRelation(newArray)
        }


    }

    const onMoveDown = option => {
        const newArray = [...subModules]
        const index = newArray.findIndex(e => e.id === option)
        // swap only if not the last
        if (index !== -1 && index < newArray.length - 1) {
            let el = newArray[index];
            newArray[index] = newArray[index + 1];
            newArray[index + 1] = el;

            console.log("Swapping: Original", subModules)
            updateRelation(newArray)
        }

    }

    // pushes the new option (from the search state) to the end
    const onAdd = option => {
        console.log(option)
        if (course === null && selectedCourseFromSearch === null) return // does nothing if no course is selected
        if (subModules.find(e => e.id === option)) return // does nothing if the option is already in the modules list

        // prevent the adding a course as a child of itself
        if ((course && course.value===option) || (selectedCourseFromSearch && selectedCourseFromSearch.value ===option)) return // if the course is the same as the selected or the autocomplete course, return

        const newArray = [...subModules]
        newArray.push(searchModules.modules.find(e => e.id === option))
        updateRelation(newArray)

    }

    // filters out the option
    const onRemove = option => {
        const newArray = subModules.filter(e => e.id !== option)
        updateRelation(newArray)
    }

    // disables the top and bottom actions buttons for the top and bottom modules
    const updateRelation = array => {
        const modules = disableActions(array)
        setSubModules(modules)
        setChangesMade(true)
    }

    //does a POST to the backend with username and the mapped modules array
    const saveRelations = async () => {
        const arrayAsString = subModules.map(e => e.id).join(",") // pull out the id's, then converts to string
        console.log("As string", arrayAsString)

        let id
        if (selectedCourseFromSearch !== null) id = selectedCourseFromSearch.value
        else id = course.value

        const res = await axios.post('/api/course/relation/' + id, {
            childCourses: arrayAsString,
            byUsername: user.user.byUsername
        }, {
            headers: { Authorization: user.accessToken }
        })
        if (res.status === 200 && mounted.current) {
            setChangesMade(false)
        }
    }

    const onEdit = option => {
        console.log(option)
        history.push('/administration/manageCourses/edit/' + option)
    }

    const onSelectCourse = option => {
        const course = searchModules.modules.find(e => e.id === option)
        setSelectedCourseFromSearch({ label: course.label, value: course.id })
    }

    const clearSelected = () => {
        setSelectedCourseFromSearch(null)
    }

    // opens a pop-up
    const onDelete = option => {
        setDeleteDialog({ open: true, id: option })

    }

    const onDeleteDialogClose = () => {
        setDeleteDialog({ open: false, id: null })

    }

    const onConfirmDelete = async () => {
        console.log(deleteDialog.id)

        const res = await axios.delete('/api/course/' + deleteDialog.id, {
            headers: { Authorization: user.accessToken }
        })
        setDeleteDialog({ open: false, id: null })
        console.log(res)
    }


    const actionButtons = [
        { icon: "up", label: "Move Up", action: onMoveUp, delete: false },
        { icon: "down", label: "Move Down", action: onMoveDown, delete: false },
        { icon: "remove", label: "Remove Relation", action: onRemove, delete: false },
        { icon: "edit", label: "Edit Course", action: onEdit, delete: false },
        // { icon: "delete", label: "Delete Course", action: onDelete, delete: true }, // removed the delete option from the submodules, as if it is in the submodules it is linked and shouldn't be able to be deleted (prevent on the backend)
    ];

    const actionButtonsTable2 = [
        { icon: "view", label: "Edit Relations", action: onSelectCourse, delete: false },
        { icon: "add", label: "Add as Sub-Course", action: onAdd, delete: false },
        { icon: "edit", label: "Edit Course", action: onEdit, delete: false },
        { icon: "delete", label: "Delete Course", action: onDelete, delete: true },
    ];

    console.log("render", changesMade, "Selected", selectedCourseFromSearch)
    return (
        <>
            <DeleteDialog open={deleteDialog.open} onClose={onDeleteDialogClose} onDelete={onConfirmDelete} />
            <PageHeader
                title="Online Training Course Administration"
                actionButtons={[{ label: "Create Course", action: onCreateCourse }]}
            />
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <h1>View Relations</h1>
                    <br />
                    {/* The input */}
                    {courseOptions === null ? <Loading /> : // if there are no current options for the autocomplete, then it is loading the options (this could lead to issues if there is an error on the backend)
                        <Grid container spacing={3}>
                            {selectedCourseFromSearch === null ?
                                <GridAutoTextField
                                    xs={12}
                                    name="course"
                                    options={courseOptions}
                                    value={course}
                                    onChange={handleCourse}
                                    label="Top-Level Course"
                                /> :

                                <Grid item xs={12}>
                                    <TextField
                                        label="Course from Search"
                                        value={selectedCourseFromSearch.label}
                                        fullWidth
                                        disabled
                                    />
                                </Grid>



                            }

                            {/* Back/Save Buttons */}
                            {!(course === null && selectedCourseFromSearch === null) &&
                                <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                                    {selectedCourseFromSearch !== null &&
                                        <Button variant="outlined" color="primary" onClick={clearSelected} style={{ margin: "0 1rem 0" }}>Back to Top-Level</Button>}
                                    {subModules !== null && (subModules.length !== 0 || changesMade === true) && //only show if submodules is an array (not loading) and if changes were made or the length of the array is not 0 (don't show when no modules found, but show if remove courses until 0 length)
                                        <Button variant="contained" color="primary" onClick={saveRelations} disabled={!changesMade} style={{ margin: "0 1rem 0" }}>Save Relations</Button>}
                                </Grid>}


                            {/* Check that the options are not loading in, and a course has not been selected */}
                            {courseOptions !== null && (course === null && selectedCourseFromSearch === null) &&
                                <Grid item xs={12}>
                                    <h6>Select a course or search for one</h6>
                                </Grid>
                            }

                        </Grid>}
                    <br />

                    {(course === null && selectedCourseFromSearch === null) ? <></> : subModules === null ? <Loading /> : // If a course is selected but the subcourses are still null, then the options are loading
                        (subModules.length === 0 && changesMade !== true) ? <h6>No sub-courses exist for this course</h6> : // if a course does not have modules added to it yet, and no changes were made (if remove all courses, still want to save changes)
                            <>
                                <SimpleTable
                                    data={subModules}
                                    cellKey={"id"}
                                    tableCells={tableCells}
                                    actionButtons={actionButtons}
                                    actions={true}
                                />

                            </>
                    }
                    {/* {course !== null && subModules !== null &&
                <> */}
                    <br /><br />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <h1>Search for Course</h1>
                    <br />
                    <SearchBarCourseTitle onSearch={handleCourseSearch} />
                    <br />
                    {searchModules.modules === null ? <></> : searchModules.loading === true ? <Loading /> : searchModules.modules.length === 0 ?
                        <h6>No courses with this title found</h6> :
                        <SimpleTable
                            data={searchModules.modules}
                            cellKey={"id"}
                            tableCells={tableCells}
                            actionButtons={actionButtonsTable2}
                            actions={true}
                        />
                    }
                    {/* </>
            } */}
                </Grid>
            </Grid>





        </>
    )
}

export default AdminManageCourses